export default __webpack_public_path__ + "static/media/logo-big.22e72122.jpg";